var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M19.389,21.083c-0.577,0-1.046,0.468-1.046,1.046 c0,0.577,0.469,1.045,1.046,1.045c0.578,0,1.047-0.468,1.047-1.045C20.436,21.55,19.967,21.083,19.389,21.083 M11.799,33.742h10.782 V11.64c0-0.591-0.481-1.072-1.073-1.072h-8.637c-0.592,0-1.072,0.481-1.072,1.072V33.742z M33.027,21.083l-2.092-2.093l1.516-1.517 l4.683,4.682l-4.683,4.683l-1.516-1.518l2.092-2.092h-6.155v-2.146H33.027z M25.8,8.422H12.871c-1.727,0-3.141,1.369-3.215,3.079 v24.387h27.461v-2.146H29.02v-8.367h-2.147v8.367h-2.146V11.64c0-0.375-0.065-0.736-0.185-1.072H25.8 c0.591,0,1.072,0.481,1.072,1.072v7.296h2.147V11.64C29.02,9.866,27.574,8.422,25.8,8.422"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.4ebf23785382760c456553998352c7ce.svg";
export { ForwardRef as ReactComponent };